
import store from '@/store';
import UserModule from '@/store/modules/User';
import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { VueTour } from 'vue-tour';

const userModule = getModule(UserModule, store);

@Component({
  name: 'my-tour'
})
export default class MyTour extends Vue implements VueTour {
    $tours: { [key: string]: any } = {};
    tour: any = {}; // Add this to satisfy TypeScript for template usage
    isClosingTutorial = false;
    
    myOptions = {
        useKeyboardNavigation: true,
    };
    
    get lastSeenVersion() {
        return userModule.user?.lastSeenTutorialVersion || 0;
    }

    get displayableSteps() {
        const stepsToDisplay = this.steps.filter((step, index) => step.introducedInVersion > this.lastSeenVersion);
        const lastStep = this.steps[this.steps.length - 1];
        if (stepsToDisplay.length > 0 && this.lastSeenVersion > lastStep.introducedInVersion) {
            stepsToDisplay.push(lastStep);
        }

        // If no steps to display, return empty array - don't show tour at all
        return stepsToDisplay;
    }

    steps = [
        {
            target: '#v-step-0',
            content: `<span style="font-size: 48px;">Witaj w <span style="color:#f25281;"><strong>RAWS</strong></span>.app
                        </span><br>
                        Jeśli jesteś u nas <b>pierwszy raz</b><br>
                        to koniecznie <b>zobacz</b> film instruktażowy!
                        <div style="
                        background: #090909;
                        margin-top: 10px;
                        margin-left: -16px;
                        margin-right: -16px;
                        margin-bottom: 16px;
                        border-bottom: 1px solid white;
                        ">
                        <img src="/img/IconRawsLearn.png" width="400px" style="margin-left: 30px; margin-bottom: -35px; margin-top: -10px;"><br>
                        </div>
                    `,
            introducedInVersion: 1,
        },
        {
            target: '#v-step-1',
            content: `<span style="font-size: 57px;">Zacznij <strong>tutaj</strong>.
                        </span><br>
                        Gdy dodasz <strong>logo</strong> i ustawisz <strong>nazwę studia</strong>,<br>
                        zajrzyj w <strong>Moje dane</strong> - szczególnie jeśli chcesz pobierać płatności od klientów.<br><br>
                        Pamiętaj, że <strong>Raws</strong> jest we wczesnej wersji!<br><strong style="font-size: 26px;">Mogą wystąpić różne błędy!</strong><br>
                        Jeśli je znajdziesz 👾 powiedz nam o nich!
                        <br>
                    `,
            introducedInVersion: 1,
        },
        {
            target: '#v-step-2',
            content: `<span style="font-size: 40px;">Jesteśmy <strong>dla Ciebie</strong>.
                        </span><br>
                        Wiemy, że nic na początku nie jest proste.<br>
                        W razie pytań naciśnij <span class="mdi mdi-help-circle-outline" style="color: #ff4081;"></span> i odezwij się do nas! Czekamy też na Twoje sugestie!<br><br>
                        <strong style="font-size:20px;">Niech się dzieje magia! ✨💖</strong><br>#TeamRaws.<br>
                `,
            introducedInVersion: 1,
        }
    ];

    async onFinish() {
        const maxVersion = Math.max(...this.steps.map(step => step.introducedInVersion));
        if (this.lastSeenVersion < maxVersion) {
            await userModule.updateLastSeenTutorialVersion(maxVersion);
        }
    }

    finishTour(finish: () => void) {
        if (this.isClosingTutorial) {
            return;
        }
        this.isClosingTutorial = true;
        window.setTimeout(() => {
            finish();
            this.isClosingTutorial = false;
        }, 320);
    }

    onNextStep() {
    }

    mounted() {
        // Only start the tour if there are steps to display and user hasn't seen all steps
        if (this.displayableSteps.length > 0) {
            (this as any).$tours['rawsTutorial'].start();
        }
    }
}
